export default {
  data() {
    return {
      isMobile: false,
      isDesktop: false,
      mobileMql: null,
      desktopMql: null
    };
  },
  computed: {
    isTablet() {
      return !this.isMobile && !this.isDesktop;
    }
  },
  mounted() {
    if (typeof window === 'undefined') return;
    // 移动：≤767px
    this.mobileMql = window.matchMedia('(max-width: 767px)');
    this.isMobile = this.mobileMql.matches;
    this.mobileMql.addEventListener('change', (e) => {
      this.isMobile = e.matches;
    });

    // 桌面：≥1025px（平板自然落入中间区域）
    this.desktopMql = window.matchMedia('(min-width: 1025px)');
    this.isDesktop = this.desktopMql.matches;
    this.desktopMql.addEventListener('change', (e) => {
      this.isDesktop = e.matches;
    });
  },
  beforeDestroy() {
    this.mobileMql?.removeEventListener('change', () => {});
    this.desktopMql?.removeEventListener('change', () => {});
  }
};